import { AppSettings } from '../app.settings';
import { OutboundScreenFiltersDataModel } from './outbound-screen-filters-data-model';

export class OutboundScreenFilterModel {
  screenCode: String = AppSettings.FILTER_SCREEN_CODE.VEHICLES_SCREEN;
  /** Filters are saved per user + screen + event; the backend rejects a save without it. */
  eventId?: String;
  filterData: OutboundScreenFiltersDataModel = new OutboundScreenFiltersDataModel();

  constructor(options?: {
    screenCode?: String,
    eventId?: String,
    filterData: OutboundScreenFiltersDataModel
  }) {
    if (options) {
      this.screenCode = options.screenCode;
      this.eventId = options.eventId;
      this.filterData = options.filterData;
    }
  }
};
